/* BLS: focus server-confirmed form results only, never infer submission success. */
(() => {
  const selectors = [
    '[data-bls-form-feedback]',
    '.blings-inquiry-success-panel',
    '.blc-success',
    '.blt2-success',
    '.bls-success',
    '.contact-form__success',
    '.contact-form__error',
    '.bls-form-message',
    '.blog-post-comments__form-message',
    '.bls-project-form .errors',
    '.blings-inquiry-form .errors',
    '.blc-form .errors',
    '.blt2-form .errors',
    '.bls-form .errors',
    '.contact-form__form .errors'
  ].join(', ');

  const showResults = () => {
    const elements = [...document.querySelectorAll(selectors)];
    if (!elements.length) return;
    const quote = document.querySelector('[data-bl-quote-wrap]');
    if (quote?.querySelector('[data-bls-form-feedback]')) quote.hidden = false;
    const visible = elements.find(node => !node.closest('[hidden]') && node.getClientRects().length);
    if (!visible) return;
    if (!visible.hasAttribute('role')) {
      const error = visible.classList.contains('errors') || visible.classList.contains('contact-form__error') || visible.querySelector('.errors');
      visible.setAttribute('role', error ? 'alert' : 'status');
    }
    if (!visible.hasAttribute('tabindex')) visible.setAttribute('tabindex', '-1');
    requestAnimationFrame(() => {
      visible.scrollIntoView({block: 'center', behavior: 'auto'});
      try { visible.focus({preventScroll: true}); } catch (_) { visible.focus(); }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showResults, {once:true});
  else showResults();
})();
